export interface Waypoint {
  id: string;
  x: number;
  y: number;
  radius: number;
  rotation: number;
}

export const PATH_PREVIEW_MODES = {
  SWERVE: 'swerve',
  SKID: 'skid',
} as const;

export type PathPreviewMode = (typeof PATH_PREVIEW_MODES)[keyof typeof PATH_PREVIEW_MODES];

export const DEFAULT_PATH_PREVIEW_MODE: PathPreviewMode = PATH_PREVIEW_MODES.SWERVE;

export interface Point {
  x: number;
  y: number;
}

export interface Path {
  name: string;
  id: string;
  isVisible: boolean;
  waypoints: Waypoint[];
  /** Speed (m/s) from waypoint[i] to waypoint[i+1]. Length = waypoints.length - 1. */
  segmentSpeeds: number[];
}

export interface ContextMenu {
  mouseX: number;
  mouseY: number;
  coords: Point;
  clickedWaypoint: Waypoint | null;
  /** Index of segment from waypoint[i] to waypoint[i+1] when opening menu on a path stroke. */
  clickedSegmentIndex: number | null;
  insertIndex: number | null;
}
